import SectionHowItWorksForTutor from './SectionHowItWorksForTutor';
export default SectionHowItWorksForTutor;
